import { css, StyledProps } from 'styled-components'

// 🚧 WORK IN PROGRESS 🚧

export const FontSize = {
  Small: css`
    font-size: 12px;
    line-height: 16px;
  `,
  Base: css`
    font-size: 14px;
    line-height: 20px;
  `,
}

export const FontWeight = {
  Light: css`
    font-weight: 300;
  `,
  Normal: css`
    font-weight: 400;
  `,
  Medium: css`
    font-weight: 400;
  `,
  SemiBold: css`
    font-weight: 600;
  `,
  Bold: css`
    font-weight: 700;
  `,
}

export const Typography = {
  Text: css`
    ${FontSize.Base}
    ${FontWeight.Normal}
  `,
  Link: css`
    color: ${(props: StyledProps<{}>) => props.theme.color.primary600};
    cursor: pointer;
    text-decoration: none;
  `,
}
